// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1ynJw","colMaxWidth":"Table_colMaxWidth__1GcYf"};